import React from "react";
// @ts-ignore
import avatar from "../../assets/images/avatar.png";
// @ts-ignore
import iris from "../../assets/images/iris.png";
import "./chat-button.scss";
import { IConfig } from "../../pages/ChatWindow";

interface ChatButtonProps {
	toggle_chat: () => void;
	show_chat: boolean;
	new_url: string;
	config: IConfig;
}

const ChatButton: React.FC<ChatButtonProps> = ({
	toggle_chat,
	show_chat,
	new_url,
	config,
}) => {
	const buttonText = new_url.includes("hcp-resources")
		? "Chat with Alex (HCP Support)"
		: config?.concierge_name ? `Chat with ${config?.concierge_name}` : "Chat with Alex";

	return (
		<button
			className="chat-button"
			onClick={toggle_chat}
			style={{
				display: show_chat ? "none" : "block",
				backgroundColor: config?.toggle_bg_color || "#2C3E50",
				color: config?.toggle_text_color || "#FFFFFF",
			}}
			aria-label={`Open chat with ${buttonText}`}
		>
			<div className="button-content">
				<div className="avatar-container-chat-button">
					<img src={config?.concierge_name?.toLowerCase() === 'iris' ? iris : avatar} alt="" className="avatar" />
					<div className="status-badge">
						<span>LIVE</span>
					</div>
				</div>
				<span
					className="button-text"
					style={{ color: config?.toggle_text_color || "#FFFFFF" }}
				>
					{buttonText}
				</span>
			</div>
		</button>
	);
};

export default ChatButton;
